import { Link } from 'react-router-dom';

import { Icon } from './icon';
import { SidebarTrigger } from './shadcn/sidebar';
import { cn } from '@/new/lib/utils';

export function Breadcrumb({
  items = [],
}: {
  items?: { href: string; label: string; active: boolean; iconClass?: string }[];
}) {
  return (
    <div className="sticky top-0 z-30 flex w-full items-center gap-3 rounded-t-lg border-b border-gray-200 bg-white/75 p-2.5 px-3.5 text-sm text-gray-500 backdrop-blur-lg duration-200">
      <SidebarTrigger />

      {items.map((item, i) => (
        <div key={item.href} className="flex items-center gap-2">
          <Link
            to={item.href}
            className={cn([
              item.active && 'text-gray-800',
              'inline-flex items-center gap-2 duration-150 hover:text-gray-800',
            ])}
          >
            {item.iconClass && <Icon className={`${item.iconClass} text-base`} />}
            <span className="line-clamp-1 max-w-52 break-all">{item.label}</span>
          </Link>

          {i < items.length - 1 && <Icon className="lucide--chevron-right text-gray-400" />}
        </div>
      ))}
    </div>
  );
}
